import { Btn } from "../../../AbstractElements";
import React, { Fragment } from "react";
import { Col, Form, Label, Row } from "reactstrap";
import { useForm } from "react-hook-form";
import * as mutations from "../../../graphql/mutations";
import { generateClient } from "aws-amplify/api";

const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});

const CompanyDetails = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  async function onSubmit(form) {
    try {
      const data = await client.graphql({
        query: mutations.createCompanyDetails,
        variables: {
          input: {
            id: "322323",
            companyName: form.companyName,
            companyBN: form.companyBN,
            companyAddress: form.companyAddress,
            logo: "Test",
            managerName: form.managerName,
            email: form.email,
            mobile: form.mobile,
          },
        },
        authMode: "API_KEY",
      });

      console.log("Created:", data);
    } catch (err) {
      console.error("Error creating company:", err);
    }
  }

  return (
    <Fragment>
      <Form
        className="needs-validation"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
      >
        <Row>
          <Col md="6 mb-3">
            <Label>Company Name</Label>
            <input
              className="form-control"
              {...register("companyName", { required: true })}
              placeholder="Company Name"
            />
            {errors.companyName && (
              <span className="text-danger">Company Name is required</span>
            )}
          </Col>

          <Col md="6 mb-3">
            <Label>Company Business Number</Label>
            <input
              className="form-control"
              {...register("companyBN", { required: true })}
              placeholder="Business Number"
            />
            {errors.companyBN && (
              <span className="text-danger">Business Number is required</span>
            )}
          </Col>
        </Row>

        <Row>
          <Col md="6 mb-3">
            <Label>Company Address</Label>
            <input
              className="form-control"
              {...register("companyAddress", { required: true })}
              placeholder="Company Address"
            />
            {errors.companyAddress && (
              <span className="text-danger">Company Address is required</span>
            )}
          </Col>

          <Col md="6 mb-3">
            <Label>Manager Name</Label>
            <input
              className="form-control"
              {...register("managerName", { required: true })}
              placeholder="Manager Name"
            />
            {errors.managerName && (
              <span className="text-danger">Manager Name is required</span>
            )}
          </Col>
        </Row>

        <Row>
          <Col md="6 mb-3">
            <Label>Email</Label>
            <input
              className="form-control"
              {...register("email", { required: true })}
              placeholder="Email"
              type="email"
            />
            {errors.email && (
              <span className="text-danger">Valid Email is required</span>
            )}
          </Col>

          <Col md="6 mb-3">
            <Label>Mobile</Label>
            <input
              className="form-control"
              {...register("mobile", { required: true })}
              placeholder="Mobile"
            />
            {errors.mobile && (
              <span className="text-danger">Mobile number is required</span>
            )}
          </Col>
        </Row>

        <Btn attrBtn={{ color: "primary" }}>Submit</Btn>
      </Form>
    </Fragment>
  );
};

export default CompanyDetails;
